import React from 'react';
import { EVLogo } from '@eagleview/ev-comp-library';
import useStyles from './EagleViewSupportLink.style';

export default function EagleViewSupportLink() {
  const classes = useStyles();
  return (
    <a
      className={classes.anchorTagStyle}
      href="https://www.eagleview.com/support/"
    >
      <EVLogo
        type="logo"
        id="evLogoIcon"
        className={classes.evLogoForSupportLink}
      />
      EagleView Support
    </a>
  );
}
